import { render, staticRenderFns } from "./FieldEmojis.vue?vue&type=template&id=6ab0def0"
import script from "./FieldEmojis.vue?vue&type=script&lang=js"
export * from "./FieldEmojis.vue?vue&type=script&lang=js"
import style0 from "./FieldEmojis.vue?vue&type=style&index=0&id=6ab0def0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports